module.exports = {
    componentDidMount: function() {
        if(!this._adsInited){
            this.initAds();
            this._adsInited = true;
        }
    },
    _adsInited : false,
    initAds: function(){
        try{
            var ads = jQuery(this.state.adWrapSelector || '#reactContainer .react-ad');
            for(var i=0, len = ads.length; i < len; i++){
                admgr.initSlot(ads[i], espn.ads.config);
            }
        }catch(e){}
    }
};


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/mixins/AdReloaderMixin.js
 **/